module.exports = __webpack_public_path__ + "static/media/arrow_left.8a0ac2ae.png";